import axios from 'axios';
import config from '../src/config';

class I18NextHttpBackend {
  constructor(options = {}) {
    this.options = {
      loadPath: '/devtools/translations/by_language/?language_code={{lng}}',
      ...options
    };
  }

  read(language, namespace, callback) {
    const loadPath = this.options.loadPath.replace('{{lng}}', language);

    axios.get(loadPath, {baseURL: config.apiUrl})
      .then(response => {
        callback(null, response.data);
      })
      .catch(error => {
        console.error('Error loading translations:', error);
        callback(error, null);
      });
  }

  static type = 'backend';
}

export default I18NextHttpBackend;